import { forwardRef } from "react";
import { ArrowDown, Phone } from "lucide-react";
import { business, hero } from "../../config/site.config";

// Opening copy over the first frame: upper-left on desktop, top of the screen on phones, clear of the bucket.
export const HeroIntro = forwardRef((_, ref) => (
  <div ref={ref} className="absolute inset-0 z-10" data-testid="hero-intro">
    <div className="pointer-events-none hero-scrim absolute inset-0" aria-hidden="true" />
    <div className="hero-float relative mx-auto max-w-[1440px] px-5 pt-[88px] sm:px-8 md:pt-[17vh] lg:px-12">
      <div className="max-w-[34rem]">
        <p className="font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-wildberry sm:text-xs" data-testid="hero-eyebrow">{hero.eyebrow}</p>
        <h1 className="mt-3 font-heading text-[1.75rem] leading-[1.05] tracking-tight text-charcoal min-[400px]:text-[2rem] sm:mt-5 sm:text-5xl lg:text-6xl" data-testid="hero-headline">
          {hero.headline}
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-charcoal-muted sm:mt-5 sm:text-base" data-testid="hero-subline">{hero.subline}</p>
        <div className="mt-4 flex flex-wrap gap-2 sm:mt-7 sm:gap-3">
          <a href="#estimate" className="inline-flex h-11 items-center bg-wildberry px-3 text-[11px] font-semibold uppercase tracking-[0.08em] text-beige transition-colors hover:bg-charcoal min-[400px]:px-4 sm:h-12 sm:px-6 sm:text-xs sm:tracking-[0.16em]" data-testid="hero-book-estimate-button">
            Book a free estimate
          </a>
          <a href={business.phoneHref} className="inline-flex h-11 items-center gap-2 border border-charcoal px-3 text-[11px] font-semibold uppercase tracking-[0.08em] text-charcoal transition-colors hover:bg-charcoal hover:text-beige min-[400px]:px-4 sm:h-12 sm:px-6 sm:text-xs sm:tracking-[0.16em]" data-testid="hero-call-button">
            <Phone className="h-4 w-4" aria-hidden="true" /> Call {business.phoneDisplay}
          </a>
        </div>
        <a href="#tour" className="mt-1 inline-flex min-h-11 items-center gap-1.5 text-xs font-semibold text-charcoal-muted underline-offset-4 hover:text-charcoal hover:underline sm:mt-3" data-testid="hero-skip-intro-link">
          Skip intro <ArrowDown className="h-3.5 w-3.5" aria-hidden="true" />
        </a>
      </div>
    </div>
  </div>
));
HeroIntro.displayName = "HeroIntro";
